import React from 'react';
import { PAIN_BODY, PAIN_EMPHASIS, PAIN_HEADLINE, PAIN_SEARCH, PAIN_WORRY_LEAD, PAIN_WORRY_QUOTE, SOLUTION_BODY, SOLUTION_CLOSING, SOLUTION_HEADLINE } from '../data/halloweenKit';
export function PainSection() {
  return <section className="w-full bg-night-900 py-14 sm:py-20" aria-labelledby="pain-title" data-id="element-210" data-mp="2uxvwxdfvostd">
      <div className="mx-auto max-w-2xl px-5" data-id="element-211" data-mp="2yy62iozrdh7p">
        <h2 id="pain-title" className="font-display text-[1.75rem] font-semibold leading-tight text-cream-50 sm:text-[2.5rem]" data-id="element-212" data-mp="2l8m4fwh4h84q">
          {PAIN_HEADLINE[0]}
          <span className="block text-pumpkin-light" data-id="element-213" data-mp="2q0djpautvrfk">{PAIN_HEADLINE[1]}</span>
        </h2>

        <div className="mt-6 space-y-3" data-id="element-214" data-mp="2bbr89k8bnjtm">
          {PAIN_BODY.map(p => <p key={p} className="text-[15.5px] leading-relaxed text-cream-200 sm:text-[17px]" data-id="element-215" data-mp="2gaaullqtuxmi">
              {p}
            </p>)}
        </div>
        <p className="mt-4 font-display text-[1.4rem] font-semibold leading-snug text-cream-50 sm:text-[1.7rem]" data-id="element-216" data-mp="22buex5azlws8">
          {PAIN_EMPHASIS}
        </p>
        <p className="mt-4 text-[15.5px] leading-relaxed text-body sm:text-[17px]" data-id="element-217" data-mp="3rlpphius9if0">{PAIN_SEARCH}</p>

        <div className="mt-6 border-l-2 border-pumpkin/60 pl-4" data-id="element-218" data-mp="3nknq920v96d1">
          <p className="text-[13px] font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-219" data-mp="5gcc2etjy3wk">{PAIN_WORRY_LEAD}</p>
          <blockquote className="mt-1.5 font-display text-[1.3rem] italic leading-snug text-pumpkin-light sm:text-[1.6rem]" data-id="element-220" data-mp="gg6ib57i4ew">
            {PAIN_WORRY_QUOTE}
          </blockquote>
        </div>

        <div className="mt-12 border-t border-night-600 pt-10" data-id="element-221" data-mp="33xycse5bz3d7">
          <h3 className="font-display text-[1.6rem] font-semibold leading-tight text-cream-50 sm:text-[2.1rem]" data-id="element-222" data-mp="33vllvbhlhio0">
            {SOLUTION_HEADLINE}
          </h3>
          <p className="mt-4 text-[15.5px] font-medium leading-relaxed text-cream-100 sm:text-[17px]" data-id="element-223" data-mp="3duuf224myt9b">{SOLUTION_BODY[0]}</p>
          <p className="mt-2 text-[15.5px] leading-relaxed text-body sm:text-[17px]" data-id="element-224" data-mp="2q470wz44n7eb">{SOLUTION_BODY[1]}</p>
          <p className="mt-6 font-display text-xl leading-snug text-cream-50 sm:text-2xl" data-id="element-225" data-mp="2l4uhkocgsigh">
            {SOLUTION_CLOSING[0]}
            <span className="block italic text-pumpkin-light" data-id="element-226" data-mp="u2n9vpq0j4a2">{SOLUTION_CLOSING[1]}</span>
          </p>
        </div>
      </div>
    </section>;
}